import styled from 'styled-components'

import InvestIcon from 'assets/icons/spend-accordion-invest.svg'
import { Body, Title } from 'components/Typography'
import { style } from 'theme'

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 450px;
  text-align: center;
  margin: 30px auto;
`

export const Icon = styled.div`
  background: rgb(255, 255, 255);
  box-shadow: 0px 3px 15px 2px rgba(0, 0, 0, 0.05);
  height: 104px;
  width: 104px;
  border-radius: 50%;
  background-image: url(${InvestIcon});
  background-position: center;
  background-repeat: no-repeat;
  background-size: 48px;
  margin-bottom: 20px;
`

export const StyledTitle = styled(Title)`
  font-weight: 600;
  margin-bottom: 10px;
`

export const StyledBody = styled(Body)`
  margin-bottom: 50px;
  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    margin-bottom: 40px;
  }
`
export const BodyContainer = styled('div')`
  @media (min-width: ${style(theme => theme.breakpoints.md)}px) {
    width: 340px;
  }
`
export const FooterContainer = styled.div`
  font-size: 12px;
  line-height 16px;
  margin: 20px auto 0;
  text-align: center;
  max-width: 450px;
  color: ${style(theme => theme.colors.stone)};

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    max-width: 100%;
    margin: 0 0 5% 0;
  }
`
export const StyledButton = styled.div`
  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    background-color: white;
    position: sticky;
    bottom: 0px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`

export const Image = styled.img`
  max-width: 100%;
  max-height: 100%;
  margin-bottom: 5%;
`
